import cls from './Separator.module.scss';

export const Separator = () => (
  <div class={cls.separator}>...</div>
);